import { Pipe, PipeTransform } from '@angular/core';

import { Event } from '../interfaces/event.interface';
import { CW_CREATOR_ID } from '../services/utils.service';
import { EVENTS_FILTER } from '../../quickstarts/events/eventsUI.service';

@Pipe({
  name: 'creator'
})
export class CreatorPipe implements PipeTransform {

  transform(value: Event[], args: EVENTS_FILTER = EVENTS_FILTER.ALL): Event[] {
    switch (args) {
      case EVENTS_FILTER.MY:
        return value.filter(evt => evt.codeItems.some(ci => ci.creator == CW_CREATOR_ID));

      default:
        return value;
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/pipes/creator.pipe.ts